import React, { useState } from 'react';
import './DesignSection.css';
import VerticalDecoration from '../components/VerticalDecoration/VerticalDecoration';

// Importez vos images ici
import enclosureImage from '../assets/images/ROBOT.png';
import lightSealImage from '../assets/images/robot-cam.png';
import BatterieImage from '../assets/images/batterie-removebg-preview.png';

const designFeatures = [
  {
    id: 'Agilité',
    title: 'Stérilité',
    description: 'Structure robuste et mobile conçue pour évoluer avec aisance dans des environnements complexes. Sa conception garantit une stabilité parfaite et une performance constante lors de toutes vos missions.',
    image: enclosureImage,
    thumbnail: enclosureImage
  },
  {
    id: 'Précision',
    title: 'Précision',
    description: "Capteur haute résolution capable de capturer les moindres détails. Il permet une analyse visuelle fine et une détection d'anomalies en temps réel, garantissant une fiabilité totale de vos données d'inspection. ",
    image: lightSealImage,
    thumbnail: lightSealImage
  },
    {
    id: 'Endurance',
    title: 'Endurance',
    description: "Batterie haute capacité intégrée. Elle garantit 6 heures d'autonomie en continu, assurant la finalisation des cycles d'analyse sans interruption et un rendement optimal de votre travail.",
    image: BatterieImage,
    thumbnail: BatterieImage
  }
];

const DesignSection = () => {
  const [activeDesign, setActiveDesign] = useState(0);

  const handlePrevious = () => {
    setActiveDesign((prev) => (prev > 0 ? prev - 1 : designFeatures.length - 1));
  };

  const handleNext = () => {
    setActiveDesign((prev) => (prev < designFeatures.length - 1 ? prev + 1 : 0));
  };

  return (
    <section className="design-section" id="design">
      <div className="design-container">
        <VerticalDecoration text="Design" />

        {/* Titre centré en haut */}
        <div className="design-header">
          <h2 className="design-title">{designFeatures[activeDesign].title}</h2>
        </div>

        {/* Image principale au centre */}
        <div className="design-main-content">
          <div className="design-image-wrapper">
            <img 
              src={designFeatures[activeDesign].image}
              alt={designFeatures[activeDesign].title}
              className="design-main-image"
              key={activeDesign}
            />
          </div>
        </div>

        {/* Bas de page : Description à gauche + Navigation miniatures */}
        <div className="design-footer">
          <div className="design-description">
            <p>{designFeatures[activeDesign].description}</p>
          </div>

          <div className="design-navigation">
            <button 
              className="design-nav-arrow design-nav-left" 
              onClick={handlePrevious}
              aria-label="Previous design feature"
            >
              ←
            </button>

            <div className="design-thumbnails">
              {designFeatures.map((feature, index) => (
                <button
                  key={feature.id}
                  className={`design-thumbnail ${activeDesign === index ? 'active' : ''}`}
                  onClick={() => setActiveDesign(index)}
                  aria-label={feature.title}
                >
                  <img 
                    src={feature.thumbnail} 
                    alt={feature.title}
                  />
                </button>
              ))}
            </div>

            <button 
              className="design-nav-arrow design-nav-right" 
              onClick={handleNext}
              aria-label="Next design feature"
            >
              →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DesignSection;